import React from 'react'
import { useState, useRef, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import { useForm } from 'react-hook-form'
import { getOrgUserGoals } from '../../api/performance/getOrgUserGoals'
import { getOrgGoal } from '../../api/OrganizationGoal/getOrgGoal'
import { ModalFooter } from 'react-bootstrap'
import { useAuthContext } from '../../hooks'
import { updateProjectGoals } from '../../api/Update/updateProjectGoals'
import parse from 'html-react-parser'
import { getOrgUsersProjects } from '../../api/project/getOrgUserProjects'
import Navbar from '../../Components/Navbar'
import ReactQuill from 'react-quill'
import { getPeopleleadCommentForUser } from '../../api/peopleLeadPerformance/getPeopleLeadCommentForUser'
import { Rate } from 'antd'
import OrgGoal from '../MagReview/orgGoal'
import GoalSc from './gaol.sc'

interface formData {
  project_id: Number
  due_date: string
  goal: string
}

function Index() {
  const auth = useAuthContext()
  const [projectGoals, setProjectGoals] = useState<any>([])
  const fetchProjectGoals = async () => {
    await getOrgUserGoals(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0],
    )
      .then((e) => {
        console.log(e)
        setProjectGoals(e)
      })
      .catch((e: any) => console.log(e))
    console.log('my goals displayed')
  }
  const [getProjects, SetGetProjects] = useState<any[]>([])
  const fetchOrgUserProjects = async () => {
    await getOrgUsersProjects(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString(),
    )
      .then((e) => {
        console.log(e)
        SetGetProjects(e)
      })
      .catch((e) => console.log(e))
  }

  type projectGoalProps = {
    length: number
    Goals: String
    DueDate: String
    Goal_id: any
    ProjectName: String
  }
  type objectiveProps = {
    objective: string
    evaluation: string
  }
  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [projectGoal, setProjectGoal] = useState<projectGoalProps>()
  useEffect(() => {}, [show, projectGoal])

  function handleShow(data: projectGoalProps) {
    setShow(true)
    setProjectGoal(data)
  }
  console.log(projectGoal)
  const handleClose = () => {
    setShow(false)
  }

  const [ojective, setObjective] = useState<objectiveProps>()
  function handleshow1(data: objectiveProps) {
    setShow1(true)
    setObjective(data)
  }

  const handleClose1 = () => {
    setShow1(false)
  }
  console.log(projectGoal)
  const [formdata, setFormData] = useState<formData>({
    project_id: 0,
    due_date: `${projectGoal?.DueDate}`,
    goal: '',
  })
  const [quillValues, setQuillValues] = useState<any>(null)

  function setQuills() {
    setQuillValues(projectGoal?.Goals)
  }

  console.log(projectGoal?.Goals, 'elloooo thereee')
  const handleChange = (e: any) => {
    const { name, value } = e.target
    setFormData((prevFormData: formData) => ({
      ...prevFormData,
      [name]: name == 'project_id' ? Number(value) : value,
    }))
  }
  const handleGoalChange = (value: string) => {
    setFormData((prevFormData: any) => ({ ...prevFormData, goal: value }))
  }
  const handleSubmit = async (e: any) => {
    e.preventDefault()
    if (!formdata.project_id || !formdata.due_date || !formdata.goal) {
      alert('Please Fill The Required Fileds')
      return
    }
    try {
      const response = await updateProjectGoals(
        auth?.userInfo?.orgs[0]?.id,
        auth?.userInfo?.orgs_user_id[0],
        projectGoal?.Goal_id,
        formdata,
      )
      console.log(response)

      setFormData({ project_id: 0, due_date: '', goal: '' })
      setShow(false)
      fetchProjectGoals()
    } catch (error) {
      console.log(error)
    }
  }

  const [peopleLeadComment, setPeopleLeadComment] = useState<any>([])
  const fetchPeopleLeadComment = async () => {
    await getPeopleleadCommentForUser(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0],
    )
      .then((e) => {
        console.log(e)
        setPeopleLeadComment(e)
      })
      .catch((e) => console.log(e))
  }
  console.log('people lead comment-----------', peopleLeadComment)
  useEffect(() => {
    fetchProjectGoals()
    fetchOrgUserProjects()
    fetchPeopleLeadComment()
  }, [])
  useEffect(() => {
    setQuills()
  }, [projectGoal?.Goals, quillValues])

  console.log('my goals 2', projectGoals)
  console.log(quillValues, 'quill vlaues see heree')
  const [rate, setRate] = useState('')
  const ratings = () => {
    if (peopleLeadComment[0]?.rating === 5) {
      setRate('Above the expectations')
    } else if (peopleLeadComment[0]?.rating === 4) {
      setRate(`Meets the expectations`)
    }
  }

  useEffect(() => {
    ratings()
  }, [rate])
  console.log('ratingsssssssssssssssss', rate, peopleLeadComment[0]?.rating)
  return (
    <GoalSc>
      <div className="user-goal-main">
        <label>Development Objective</label>
        {projectGoals &&
          projectGoals?.map((data: any, idx: any) => {
            return (
              <>
                {data.objective ? (
                  data?.objective?.map((data: any) => {
                    return (
                      <>
                        <div className="objective-main">
                          <div className="type">
                            <div>Evaluation:{data?.Evaluation}</div>
                            <div>Evaluation Type:{data?.objective_name}</div>
                          </div>
                          <div className="evaluation-main">
                            {parse(data?.Objective)}
                          </div>
                        </div>
                      </>
                    )
                  })
                ) : (
                  <div>*No Devlopment Goals Found*</div>
                )}
              </>
            )
          })}

        <label>My Project Goals</label>
        {projectGoals &&
          projectGoals?.map((data: any) => {
            return (
              <>
                {data?.project_goals ? (
                  data?.project_goals?.map((_: any, idx: any) => {
                    return (
                      <>
                        <div className="user-gaol-title-main">
                          <label key={idx}>
                            Project Name:{_?.ProjectName}{' '}
                          </label>
                          <div key={idx}>Due Date : {_?.DueDate}</div>
                        </div>
                        <div className="project-goals-main">
                          <div className="user-goal-title" key={idx}>
                            <label>Goal:</label>
                            {parse(_?.Goals)}
                            <label>Project lead comment:</label>
                            <div className="project_lead_commment">
                              {_.project_lead_comment &&
                                parse(String(_?.project_lead_comment))}
                            </div>
                          </div>

                          <Button
                            className="goal-edit-button"
                            onClick={() => handleShow(_)}
                          >
                            Edit Goal
                          </Button>
                        </div>
                      </>
                    )
                  })
                ) : (
                  <div>*No Project Goals Found*</div>
                )}
              </>
            )
          })}
      </div>

      <Modal
        id="AddRpm"
        className="modal-objective"
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        height="100"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">Apply PPM</Modal.Title>
          <button
            className="modal-close-button"
            onClick={() => {
              handleClose()
            }}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="objective-modal">
              <label>Project Name:</label>
              <div>{projectGoal?.ProjectName}</div>
              <div>
                <label>Previous Goal:</label>
                {projectGoal && parse(String(projectGoal?.Goals))}
              </div>

              <label>Due Date:</label>
              {projectGoal?.DueDate}

              <div className="evaluation-objective-container">
                <div className="evaluation-container">
                  <label>Project Goals</label>
                  <select
                    onChange={handleChange}
                    className="project"
                    name="project_id"
                  >
                    <option value="">Select Your Projects</option>
                    {getProjects?.map((data) => {
                      return (
                        <>
                          <option value={parseInt(data?.ProjectId)}>
                            {data?.ProjectName}
                          </option>
                        </>
                      )
                    })}
                  </select>
                  <label>Due Date: {projectGoal?.DueDate}</label>
                  <input
                    className="due-dates"
                    type="date"
                    value={formdata?.due_date}
                    onChange={handleChange}
                    name="due_date"
                  />
                </div>
              </div>
              <div className="objective-modal-main"></div>
              <ReactQuill
                defaultValue={String(projectGoal?.Goals)}
                onChange={handleGoalChange}
              />
              <button type="submit" className="objective-submit">
                Submit
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <OrgGoal />
      <div className="user-gaol-title-main">
        {peopleLeadComment?.map((data: any) => {
          return (
            <>
              <div>
                <Rate disabled allowHalf defaultValue={data?.rating} />
                <div>{data?.final_review}</div>
                <div></div>
              </div>

              <div>
                <label>People Lead Comment</label>
                <div>{parse(data?.pl_comment)}</div>
              </div>
            </>
          )
        })}
      </div>
    </GoalSc>
  )
}

export default Index
